import { apiClientGeral, apiClientAudio } from '@/plugins/axios'

export default {
  getUras() {
    return apiClientGeral().get('/ura')
  },
  getUra(id) {
    return apiClientGeral().get(`/ura/${id}`)
  },
  getUraUse(id) {
    return apiClientGeral().get(`/ura/use/${id}`)
  },
  postUra(ura) {
    return apiClientGeral().post('/ura', ura)
  },
  putUra(ura) {
    return apiClientGeral().put(`/ura/${ura._id}`, ura)
  },
  deleteUra(id) {
    return apiClientGeral().delete(`/ura/${id}`)
  },

  getAudios() {
    return apiClientAudio().get('/audio')
  },
  getrotas() {
    return apiClientGeral().get('/rotas')
  },
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas')
  },
}
